import { ColumnDef } from "@tanstack/react-table";
import { compareColumnAlphanumeric, createNumberColumn } from "../commonTableComponents/utils";
import { PanelListElement } from "../../../eventBus/panelListEventPayloads";

export const panelListColumns: ColumnDef<PanelListElement>[] = [
    {
        id: "numberId",
        header: "No.",
        accessorKey: "number",
        filterFn: "equalsString",
    },
    {
        id: "installationSequenceHeaderId",
        header: "",
        columns: [createNumberColumn("installationSequenceId", "Installation sequence", "installationSequence", true)],
    },
    {
        header: "PANEL MARKING",
        columns: [
            { id: "containerNumberId", header: "Container No.", accessorKey: "containerNumber" },
            {
                id: "panelTypeId",
                header: "Panel Type",
                accessorKey: "panelType",
                sortingFn: compareColumnAlphanumeric<PanelListElement>(),
            },
            {
                id: "panelIdId",
                header: "Panel ID",
                accessorKey: "panelId",
                sortingFn: compareColumnAlphanumeric<PanelListElement>(),
            },
        ],
    },
    {
        header: "PANEL PARAMETERS",
        columns: [
            createNumberColumn("heightMmId", "Height, mm", "heightMm"),
            createNumberColumn("widthMmId", "Width, mm", "widthMm"),
            createNumberColumn("widthLMmId", "Width L, mm", "widthLMm"),
            createNumberColumn("widthRMmId", "Width R, mm", "widthRMm"),
            createNumberColumn("depth", "Depth, mm", "depthMm"),
            createNumberColumn("areaM2Id", "Area, m²", "areaM2"),
            { id: "floorId", header: "Floor", accessorKey: "floor" },
            { id: "windowDoorTypeId", header: "Window/Door Type", accessorKey: "windowDoorType" },
            { id: "sideId", header: "Side", accessorKey: "side" },
            { id: "typeId", header: "Type", accessorKey: "type" },
            createNumberColumn("weightKgId", "Weight (kg)", "weightKg"),
            createNumberColumn("weightLbsId", "Weight (lbs)", "weightLbs"),
        ],
    },
];
